export const mapConstants = {
    SET_INFO_WINDOW: 'MAP_SET_INFO_WINDOW',
    SET_DRAWING_MANAGER: 'MAP_SET_DRAWING_MANAGER',
    SHOW_LAYER: 'MAP_SHOW_LAYER',
    RESET_LAYERS: 'MAP_RESET_LAYERS',
};
